























import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component({})
export default class ProgressDialogComponent extends Vue {
  @Prop()
  public text?: string;

  @Prop()
  public isLoadingProp = false;

  private isLoading = this.isLoadingProp;

  @Watch('isLoadingProp')
  public onChangeisLoadingProp(newVal: boolean) {
    this.isLoading = newVal;
  }
}
